/* Blackeyz : outil « Ma voiture est-elle vulnérable ? » (chargé uniquement avec la section) */
(() => {
  if (customElements.get('vulnerability-tool')) return;

  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const option = (value, label) => `<option value="${esc(value)}">${esc(label)}</option>`;
  const lang = document.documentElement.lang || 'en';

  class VulnerabilityTool extends HTMLElement {
    connectedCallback() {
      const raw = this.querySelector('[data-tool-config]');
      if (!raw) return;
      try { this.config = JSON.parse(raw.textContent); } catch (e) { return; }
      this.form = this.querySelector('form');
      this.brand = this.querySelector('[data-brand]');
      this.model = this.querySelector('[data-model]');
      this.year = this.querySelector('[data-year]');
      this.result = this.querySelector('[data-result]');
      this.cars = (this.config.cars || []).filter((c) => c.brand && c.model);
      // Marques et modèles des métaobjets : complètent les voitures réglées en blocs, sans les remplacer
      const known = new Set(this.cars.map((c) => `${c.brand}|${c.model}`));
      (this.config.brands || []).forEach((b) => (b.models || []).forEach((model) => {
        if (b.brand && model && !known.has(`${b.brand}|${model}`)) this.cars.push({ brand: b.brand, model, risk: 'medium' });
      }));

      const brands = [...new Set(this.cars.map((c) => c.brand))].sort((a, b) => a.localeCompare(b, lang));
      this.brand.insertAdjacentHTML('beforeend', brands.map((b) => option(b, b)).join('') + option('__other', this.config.labels.other));

      this.brand.addEventListener('change', () => this.fillModels());
      this.model.addEventListener('change', () => this.fillYears());
      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.evaluate(); });
    }

    fillModels() {
      const b = this.brand.value;
      const models = [...new Set(this.cars.filter((c) => c.brand === b).map((c) => c.model))].sort((x, y) => x.localeCompare(y, lang, { numeric: true }));
      this.model.innerHTML = option('', this.config.labels.choose) + models.map((m) => option(m, m)).join('') + option('__other', this.config.labels.other);
      this.model.disabled = !b || b === '__other';
      this.year.innerHTML = option('', this.config.labels.year || '');
      this.year.disabled = true;
    }

    fillYears() {
      const entries = this.cars.filter((c) => c.brand === this.brand.value && c.model === this.model.value);
      const now = new Date().getFullYear();
      const from = Math.min(...entries.map((c) => c.from || now - 15), now);
      const to = Math.max(...entries.map((c) => c.to || now), from);
      let html = option('', this.config.labels.choose);
      for (let y = to; y >= from; y -= 1) html += option(y, y);
      this.year.innerHTML = html;
      this.year.disabled = entries.length === 0;
    }

    evaluate() {
      const keyless = this.form.elements.keyless.value;
      const year = parseInt(this.year.value, 10);
      const car = this.cars.find((c) => c.brand === this.brand.value && c.model === this.model.value && (!year || ((!c.from || year >= c.from) && (!c.to || year <= c.to))));
      const { messages, labels } = this.config;
      let risk = 'medium';
      let message = messages.unknown_car;
      let product = this.config.default;

      if (keyless === 'no') {
        risk = 'low';
        message = messages.not_keyless;
      } else if (car) {
        risk = car.risk || 'medium';
        message = messages[risk] || messages.medium;
        product = car.product || product;
      }

      const note = car && car.note ? `<p class="xsmall muted">${esc(car.note)}</p>` : '';
      let productHtml = '';
      if (product && keyless !== 'no') {
        productHtml = `
          <div class="cart-reco" style="margin-top:6px">
            <span class="media">${product.image ? `<img src="${esc(product.image)}" alt="" width="56" height="56" loading="lazy">` : ''}</span>
            <span class="stack" style="--gap:2px">
              <span class="xsmall muted">${esc(labels.recommended)}</span>
              <a class="small" href="${esc(product.url)}"><strong>${esc(product.title)}</strong></a>
              <span class="small">${esc(product.price)}</span>
            </span>
            <form action="${esc(window.theme?.routes?.cartAdd?.replace('.js', '') || '/cart/add')}" method="post" class="js-product-form">
              <input type="hidden" name="id" value="${esc(product.variant)}">
              <button type="submit" class="btn" data-add-button ${product.available ? '' : 'disabled'}>${esc(labels.add)}</button>
            </form>
          </div>`;
      }

      this.result.innerHTML = `<span class="risk risk--${esc(risk)}">${esc(labels[risk])}</span><p>${esc(message)}</p>${note}${productHtml}`;
      this.result.hidden = false;
      this.result.focus({ preventScroll: true });
      this.dispatchEvent(new CustomEvent('tool:result', { bubbles: true, detail: { risk } }));
    }
  }

  customElements.define('vulnerability-tool', VulnerabilityTool);
})();
